import { Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { toggleLoader } from '../../../Store/loader/loaderReducer'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'

const type_option = ['centilio_crawl_prompt', 'wix_crawl_prompt', 'wordpress_crawl_prompt', 'centilio_signle_post', 'wix_signle_post', 'wordpress_signle_post'];
const AiPrompt = () => {
    const [formValue, setFormValue] = useState({ type: 'ai_blog', prompt: ``, updatedPrompt: `` })
    const dispatch = useDispatch();
    const org_info = useSelector((state) => state?.org_info?.value);
    const org_Value = org_info?.default_organizations?.Id;
    const [org_Id, setOrg_Id] = useState()
    const [action, setAction] = useState('')

    let data = { type: formValue.type, prompt: formValue.updatedPrompt, org_id: org_Id ? org_Id : 0 }


    useEffect(() => {
        _getPrompt(org_Value);
    }, []);


    const _getPrompt = (org_Value, type) => {
        let data = { type: type ? type : formValue?.type, org_id: org_Value }

        axios.get(process.env.REACT_APP_AIPROMPT, { params: data, withCredentials: process.env.REACT_APP_CREDENTIALS })
            .then((res) => {
                let data = res?.data?.data;
                if (data?.Prompt) {
                    setFormValue({ ...formValue, type: data?.Type, updatedPrompt: data?.Prompt ? data.Prompt : `` });
                } else {
                    if (type) setFormValue({ ...formValue, type: type, updatedPrompt: `` });
                }
                setOrg_Id(org_Value);
                dispatch(toggleLoader(false));
            })

            .catch((err) => {
                const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
                const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
                toast.error(dynamicValue || "No valid prompt found for this organization.");
                dispatch(toggleLoader(false))
            })
    }


    const handleSubmit = () => {

        if (action === 'Create') {
            axios.post(process.env.REACT_APP_AIPROMPT, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
                .then((res) => {
                    dispatch(toggleLoader(false))
                    toast.success('Success');
                    // _getPrompt(data?.org_id);
                })
                .catch((err) => {
                    const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
                    const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
                    toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
                    dispatch(toggleLoader(false))
                })
        }
        else {
            delete data.prompt;
            axios.delete(process.env.REACT_APP_AIPROMPT, { data, withCredentials: process.env.REACT_APP_CREDENTIALS })
                .then((res) => {
                    dispatch(toggleLoader(false))
                    toast.success('Deleted');
                    setFormValue((prev) => ({
                        ...prev,
                        updatedPrompt: ''
                    }))
                })

                .catch((err) => {
                    const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
                    const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
                    toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
                    dispatch(toggleLoader(false))
                })
        }
    }


    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            _getPrompt(data?.org_id);
        }
    };
    return (
        <Box sx={{ padding: "0px 40px", width: '100%', display: 'flex', gap: '20px', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', padding: '5px', gap: '20px' }}>
                <Box sx={{ paddingTop: '5px', width: '200px', textAlign: 'center' }} >Org Id:</Box>
                <FormControl size="small" sx={{ width: "100%" }} >
                    <OutlinedInput
                        id="outlined-adornment-weight"
                        value={org_Id}
                        style={{ height: 35, width: '250px' }}
                        onChange={e => setOrg_Id(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                </FormControl>
            </Box>
            <Box sx={{ display: 'flex', padding: '5px', gap: '20px' }}>
                <Box sx={{ paddingTop: '5px', width: '200px', textAlign: 'center' }} >Type:</Box>
                <FormControl size="small" sx={{ width: "100%" }} >
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"

                        value={formValue.type}
                        onChange={(e) => _getPrompt(data?.org_id, e.target.value)}
                        style={{ height: 35, width: '250px' }}
                    >
                        {type_option.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            {/* <Box sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', padding: '5px', gap: '20px' }}>
                    <Box sx={{ paddingTop: '5px', width: '200px', textAlign: 'center' }} >Prompt:</Box>
                    <FormControl size="small" sx={{ width: "100%" }} >
                        <TextField style={{ width: '100%' }}
                            minRows={5}
                            maxRows={5}
                            multiline
                            value={formValue.prompt}
                            placeholder='The prompt should have this title placeholder: {{TITLE_PROMPT_PLACEHOLDER}}'
                            onChange={(e) => setFormValue({ ...formValue, prompt: e.target.value })}
                        />
                    </FormControl>
                </Box>
            </Box> */}
            {/* {formValue.updatedPrompt.length &&  */}
            <Box sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', padding: '5px', gap: '20px' }}>
                    <Box sx={{ paddingTop: '5px', width: '200px', textAlign: 'center' }} >Live Prompt :</Box>
                    <FormControl size="small" sx={{ width: "100%" }} >

                        <TextField style={{ width: '100%' }}
                            minRows={15}
                            maxRows={17}
                            multiline
                            value={formValue.updatedPrompt}
                            // placeholder='The prompt should have this title placeholder: {{TITLE_PROMPT_PLACEHOLDER}}'
                            // onChange={(e) => _getPrompt(data?.org_id, e.target.value)}
                            onChange={(e) => setFormValue((prev) => ({
                                ...prev,
                                updatedPrompt: e.target.value
                            }))}

                        // disabled
                        />
                    </FormControl>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', padding: '5px', gap: '20px' }}>
                <Box sx={{ paddingTop: '5px', width: '200px', textAlign: 'center' }} >Action:</Box>
                <FormControl size="small" sx={{ width: "100%" }} >
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={action}
                        onChange={(e) => setAction(e.target.value)}
                        style={{ height: 35, width: '250px' }}
                    >
                        <MenuItem value="Create">Create</MenuItem>
                        <MenuItem value="Delete">Delete</MenuItem>
                    </Select>
                </FormControl>

            </Box>
            <Box>


                <Box sx={{ width: '100%', textAlign: 'end' }}>
                    <Button variant="contained" onClick={handleSubmit}>Submit</Button>
                </Box>
            </Box>

            {/* } */}


        </Box>
    )
}

export default AiPrompt